angular.module('survey').factory('rangeConfig', [rangeConfig]);

function rangeConfig() {
  /**
   * Resolves a Range question's `range_ticks` string into slider mechanics.
   *
   * Resolution order:
   *   1. Strictly ascending numeric list (e.g. "0,25,50,75,100") -> used
   *      exactly as entered.
   *   2. Non-numeric list (e.g. "yes,maybe,no"), or a numeric list
   *      descending by exactly one each step (e.g. "5,4,3,2,1") -> a 1..N
   *      range derived from the item count alone. The literal values/order
   *      are never read for min/max, only counted.
   *   3. Anything else (uneven-step descending numbers, scattered or
   *      duplicate values, fewer than 2 tokens, null/empty) -> flat 0-100
   *      fallback.
   *
   * @param {string|null|undefined} rangeTicks - The question's raw
   *   comma-separated range_ticks value.
   * @returns {{min: number, max: number, default: number, valid: boolean}}
   *   `default` is always Math.round((min + max) / 2), so it's a whole
   *   number regardless of which outcome produced min/max.
   */
  return function (rangeTicks) {
    var FALLBACK = { min: 0, max: 100, default: 50, valid: false };
    if (!rangeTicks) return FALLBACK;

    var tokens = rangeTicks.split(',').map(function (s) {
      return s.trim();
    });
    if (
      tokens.length < 2 ||
      tokens.some(function (t) {
        return t === '';
      })
    ) {
      return FALLBACK;
    }

    var nums = tokens.map(Number);
    var allNumeric = nums.every(function (n) {
      return isFinite(n);
    });

    if (allNumeric) {
      var isAscending = nums.every(function (n, i) {
        return i === 0 || n > nums[i - 1];
      });
      if (isAscending) {
        return toRange(nums[0], nums[nums.length - 1]);
      }

      var isDescendingByOne = nums.every(function (n, i) {
        return i === 0 || n === nums[i - 1] - 1;
      });
      if (isDescendingByOne) {
        return toRange(1, tokens.length);
      }

      return FALLBACK;
    }

    return toRange(1, tokens.length);

    /**
     * @param {number} min
     * @param {number} max
     * @returns {{min: number, max: number, default: number, valid: true}}
     */
    function toRange(min, max) {
      return {
        min: min,
        max: max,
        default: Math.round((min + max) / 2),
        valid: true,
      };
    }
  };
}

// Exposes the same rangeConfig resolution as a template filter, e.g.
// `{{ (question.range_ticks | rangeConfig).min }}`.
angular
  .module('survey')
  .filter('rangeConfig', [
    'rangeConfig',
    function (rangeConfig) {
      return rangeConfig;
    },
  ]);
